module.exports = __webpack_public_path__ + "img/corner_up.4bd4edc7.gif";